export function SecuritySection({ points }) {
  return (
    <section className="security-section" id="security">
      <div>
        <p className="eyebrow eyebrow--light">SECURE BY DESIGN</p>
        <h2>大切なファイルへの経路を、閉じたまま。</h2>
      </div>

      <ul className="security-list">
        {points.map((point) => (
          <li key={point}>
            <span aria-hidden="true">✓</span>
            {point}
          </li>
        ))}
      </ul>
    </section>
  );
}
